import { actions, types } from './requests'
export const GETIMAGELIST_TYPES = {
    ...types('GETIMAGELIST'),
}
export const GETIMAGELIST_ACTIONS = {
    ...actions('GETIMAGELIST'),
}
